import ResetPassword from "./resetPasswordContainer";
export default ResetPassword;
